(function (w, d, s) {
  const a = d.getElementsByTagName('head')[0]
  const r = d.createElement('script')
  r.async = 1
  r.src = s
  r.setAttribute('id', 'usetifulScript')
  r.dataset.token = '1682ebc36d15cc645c98f1670dbfcf37'
  a.appendChild(r)
})(window, document, 'https://www.usetiful.com/dist/usetiful.js')
